import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ICalendarEventResource } from "../types";

export interface ICalendarEventDeleteRecurrenciesMutationParameters {
    calendarEvent: RelationalValue<ICalendarEventResource>;
}

export type ICalendarEventDeleteRecurrenciesMutationResult = void;

export const calendarEventDeleteRecurrenciesMutation: IApiMutationFunction<
    ICalendarEventDeleteRecurrenciesMutationParameters
> = ({ calendarEvent }) => {
    return {
        method: "DELETE",
        url: `/calendar-events/${mapRelationalValue(calendarEvent)}/recurrencies`,
    };
};

export const useCalendarEventDeleteRecurrenciesMutation = createApiMutationHook<
    ICalendarEventDeleteRecurrenciesMutationParameters,
    ICalendarEventDeleteRecurrenciesMutationResult
>(calendarEventDeleteRecurrenciesMutation);
